import script from "./CoordinationMechanism.vue?vue&type=script&setup=true&lang=ts"
export * from "./CoordinationMechanism.vue?vue&type=script&setup=true&lang=ts"

import "./CoordinationMechanism.vue?vue&type=style&index=0&id=15c391f8&lang=less&scope=true"

const __exports__ = script;

export default __exports__